module.exports = __webpack_public_path__ + "img/paishui-1.d895dfa4.png";